
/*
  SUMMARY
    0 - Funtions
    1 - Animations
    2 - Swiper Sliders

*/

/*---------------- 0 - Functions -------------------*/
function animateSVG() {
  anime({
    targets: '.svg-path-animate path',
    strokeDashoffset: [anime.setDashoffset, 0],
    easing: 'easeInOutSine',
    duration: 2000,
    delay: 0,
    loop: false
  });

  anime({
    targets: '.svg-path-animate',
    opacity: 1,
    easing: 'easeInOutSine',
    duration: 1000,
    delay: 0,
    loop: false
  });

}

/*---------------- 1 - Animations -------------------*/
// Svg
const SVGSToBeAnimated = document.querySelectorAll('.svg-path-animate')
SVGSToBeAnimated.forEach(svg => {
  gsap.to(svg, {
    scrollTrigger: {
      trigger: svg,
      start: "top 90%",
    },
    onComplete: () => animateSVG()
  });
})

/*---------------- 2 - Swiper Sliders -------------------*/
if (window.screen.width < 800) {
  var swiper = new Swiper(".swiper--category", {
    loop: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 14,
  });
}